import { useRef } from 'react';
import { Box } from '@mui/material';
import { useAIChatContext } from '../context/AIChatContext';

/** Draggable divider on the sidebar's left edge — dragging left/right adjusts `AIChatContext`'s width, clamped by the provider itself. */
export function AIChatResizeHandle() {
  const { width, setWidth } = useAIChatContext();
  const startRef = useRef<{ x: number; width: number } | null>(null);

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    startRef.current = { x: e.clientX, width };

    const handleMouseMove = (moveEvent: MouseEvent) => {
      if (!startRef.current) return;
      const delta = startRef.current.x - moveEvent.clientX;
      setWidth(startRef.current.width + delta);
    };
    const handleMouseUp = () => {
      startRef.current = null;
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <Box
      onMouseDown={handleMouseDown}
      sx={{
        width: 5,
        flexShrink: 0,
        cursor: 'col-resize',
        '&:hover': { bgcolor: 'primary.main', opacity: 0.4 },
      }}
    />
  );
}
